const messageTypes = {
	SHOW_MESSAGE: 'SHOW_MESSAGE',
	SHOW_INITIAL_STATE: 'SHOW_INITIAL_STATE',
};
export default messageTypes;
